import { render, staticRenderFns } from "./NewQuestion.vue?vue&type=template&id=01aa7d14&scoped=true&"
import script from "./NewQuestion.vue?vue&type=script&lang=js&"
export * from "./NewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NewQuestion.vue?vue&type=style&index=0&id=01aa7d14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa7d14",
  null
  
)

export default component.exports